import { BadgePercent, Truck, EyeOff } from "lucide-react";

const HomeChefPainPoints = () => {
  const items = [
    {
      icon: (
        <BadgePercent size={32} strokeWidth={1.5} className="text-red-500" />
      ),
      title: "Exploitative Commissions",
      desc: "Stop giving away 30% to delivery apps. Keep your profits where they belong—in your kitchen.",
    },
    {
      icon: <Truck size={32} strokeWidth={1.5} className="text-orange-500" />,
      title: "Logistical Barriers",
      desc: `Don't worry about drivers or delivery zones. Our integrated fleet handles the "last mile" perfectly.`,
    },
    {
      icon: <EyeOff size={32} strokeWidth={1.5} className="text-yellow-600" />,
      title: "Market Invisibility",
      desc: "Stand out from the fast-food noise. Our AI-driven platform targets customers who value authentic, premium home cooking.",
    },
  ];

  return (
    <section className="hc-section-painpoints">
      <div className="container text-center">
        <h2 className="hc-section-title">
          The Friction Between
          <br />
          Artistry and Business.
        </h2>
        <div className="row mt-5 ">
          {items.map((item, i) => (
            <div className="col-md-4 text-start" key={i}>
              <div className="hc-pain-icon">{item.icon}</div>
              <h5 className="hc-pain-title">{item.title}</h5>
              <p className="hc-pain-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeChefPainPoints;
